import { useEffect, useState } from "react";

import genericImageSrc from "@/assets/logos/generic.svg";

type VendorLogoProps = {
  logo_url: string;
  size?: "sm" | "md";
};
const VendorLogo = ({ logo_url, size = "sm" }: VendorLogoProps) => {
  const [imageSrc, setImageSrc] = useState<string>(genericImageSrc);
  const onImageLoadError = () => setImageSrc(genericImageSrc);

  useEffect(() => {
    setImageSrc(logo_url);
  }, [logo_url]);

  return (
    <div
      key={imageSrc}
      className={`
        ${size === "md" ? "size-10" : "size-5"}
        mr-2.5 inline-flex
      `}
    >
      <img src={imageSrc} alt="" onError={onImageLoadError} />
    </div>
  );
};

export default VendorLogo;
